export default "__VITE_ASSET__DPiLJmOr__"